import innerHeightUnit from './constants/inner-height-unit';
import accordions from './modules/block/accordions';
import directionsMap from './modules/block/directions-map';
import gallery from './modules/block/gallery';
import HeroBackgroundVideo from './modules/block/hero-background-video';
import imageSlider from './modules/block/image-slider';
import jwplayer from './modules/block/jwplayer';
import programStaffCard from './modules/block/program-staff-card';
import reasonImages from './modules/block/reason-images';
import RelatedProgramsSlider from './modules/block/related-programs-slider';
import tabs from './modules/block/tabs';
import testimonialsSlider from './modules/block/testimonials-slider';
import video from './modules/block/video';
import videoYearbook from './modules/block/video-yearbook';
import AdditionalMenu from './modules/header/additional-menu';
import mainHeader from './modules/header/main-header';
import MobileMenu from './modules/header/mobile-menu';
import PrimaryMenu from './modules/header/primary-menu';
import TopBar from './modules/header/top-bar';
import HeroFullHeight from './modules/page/hero-full-height';
import lazyLoading from './modules/page/lazy-loading';
import setBrowserClass from './modules/page/set-browser-class';
import VideoLightbox from './modules/page/video-lightbox';
import activitiesSlider from './modules/single-activity/activities-slider';
import LinksSlider from './modules/single-program/links-slider';
import menuSlider from './modules/single-program/menu-slider';
import programSlider from './modules/single-program/program-slider';
import { sampleSchedule, sampleScheduleResize } from './modules/single-program/sample-schedule';
document.querySelector('html')?.classList.remove('no-js');
HeroFullHeight.init();
videoYearbook();
setBrowserClass();
TopBar.init();
PrimaryMenu.init();
AdditionalMenu.init();
MobileMenu.init();
accordions();
programSlider();
menuSlider();
LinksSlider.init();
VideoLightbox.init();
RelatedProgramsSlider.init();
directionsMap();
imageSlider();
video();
jwplayer();
tabs();
gallery();
reasonImages();
programStaffCard();
testimonialsSlider();
activitiesSlider();
sampleSchedule();
innerHeightUnit();
setTimeout(() => {
    mainHeader();
}, 500);
window.addEventListener('load', () => {
    lazyLoading();
    HeroBackgroundVideo.init();
});
window.addEventListener('resize', () => {
    AdditionalMenu.setMenuHeight();
    PrimaryMenu.setMenuHeight();
    MobileMenu.setMenuHeight();
    MobileMenu.setAdditionalMenuHeight();
    mainHeader();
    RelatedProgramsSlider.resized();
    HeroBackgroundVideo.setSize();
    LinksSlider.init();
    sampleScheduleResize();
    innerHeightUnit();
    HeroFullHeight.resized();
});
window.addEventListener('scroll', () => {
    lazyLoading();
});
globalThis.addEventListener('orientationchange', () => {
    AdditionalMenu.closeMenu();
    PrimaryMenu.closeMenu();
    MobileMenu.closeMenu();
    MobileMenu.closeAdditionalMenu();
    // Fix for blinking/hiding footer on orientation change
    window.scrollTo(window.scrollX, window.scrollY - 1);
});
